var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveWorkflow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_383_79342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 3.33333C10 4.43789 9.1046 5.33333 8 5.33333C6.8954 5.33333 6 4.43789 6 3.33333C6 2.22876 6.8954 1.33333 8 1.33333C9.1046 1.33333 10 2.22876 10 3.33333Z",
    stroke: "#3469E7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 5.33333V5.99999M8.00016 5.99999C8.00016 6.62125 8.00016 6.93186 8.11856 7.17693C8.27643 7.50359 8.5793 7.76319 8.96043 7.89853C9.2463 7.99999 9.6087 7.99999 10.3335 7.99999C11.0583 7.99999 11.4207 7.99999 11.7066 8.10146C12.0877 8.23679 12.3906 8.49639 12.5484 8.82306C12.6668 9.06813 12.6668 9.37873 12.6668 9.99999V10.6667M8.00016 5.99999C8.00016 6.62125 8.00016 6.93186 7.88176 7.17693C7.7239 7.50359 7.42103 7.76319 7.0399 7.89853C6.75403 7.99999 6.39163 7.99999 5.66683 7.99999C4.94203 7.99999 4.57963 7.99999 4.29377 8.10146C3.91261 8.23679 3.60978 8.49639 3.4519 8.82306C3.3335 9.06813 3.3335 9.37873 3.3335 9.99999V10.6667",
    stroke: "#3469E7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 12.6667C5.3335 13.7713 4.43806 14.6667 3.3335 14.6667C2.22893 14.6667 1.3335 13.7713 1.3335 12.6667C1.3335 11.5621 2.22893 10.6667 3.3335 10.6667C4.43806 10.6667 5.3335 11.5621 5.3335 12.6667Z",
    stroke: "#3469E7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6665 12.6667C14.6665 13.7713 13.7711 14.6667 12.6665 14.6667C11.5619 14.6667 10.6665 13.7713 10.6665 12.6667C10.6665 11.5621 11.5619 10.6667 12.6665 10.6667C13.7711 10.6667 14.6665 11.5621 14.6665 12.6667Z",
    stroke: "#3469E7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_383_79342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveWorkflow);
export default __webpack_public_path__ + "static/media/active-workflow.57de14aaede5b7e0d5a2cf7abf2ff91c.svg";
export { ForwardRef as ReactComponent };